import './StoresByBookingPage.less';

export const prefix = 'bm-p-stores-by-booking';

export { default } from './StoresByBookingPage';
